var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66681 2.99992V6.99992H3.66681V2.99992H7.66681ZM1.00015 0.333252V9.66658H10.3335V0.333252H1.00015ZM14.3335 0.333252H25.0002V2.99992H14.3335V0.333252ZM14.3335 9.66658H25.0002V12.3333H14.3335V9.66658ZM14.3335 18.9999H25.0002V21.6666H14.3335V18.9999ZM11.2763 16.6094L9.39067 14.7238L5.00015 19.1143L2.60961 16.7238L0.723999 18.6094L5.00015 22.8855L11.2763 16.6094Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/approvals.e00ef8a6a79b65189a723900814bbf9d.svg";
export { ForwardRef as ReactComponent };